import ApiService from "./base";
import { config } from "@/utils/config";
function transformChangelog(changelog) {
    return {
        changelogId: changelog.ChangelogId,
        version: changelog.Version,
        title: changelog.Title,
        description: changelog.Description,
        releaseDate: changelog.ReleaseDate,
        distribution: changelog.Distribution,
        changes: (changelog.Changes ?? []).map((change)=>({
                type: change.type,
                description: change.description,
                tags: change.tags
            })),
        badges: changelog.Badges,
        downloadUrl: changelog.DownloadUrl,
        fileSize: changelog.FileSize,
        fileName: changelog.FileName,
        createdAt: changelog.CreatedAt,
        updatedAt: changelog.UpdatedAt
    };
}
export default class ChangelogsService extends ApiService {
    constructor(){
        super({
            baseURL: config.apiUrl
        });
    }
    async getChangelogs(limit, nextToken, distribution = 'blast-c') {
        const params = new URLSearchParams();
        if (limit) {
            params.append('limit', limit.toString());
        }
        if (nextToken) {
            params.append('nextToken', nextToken);
        }
        params.append('distribution', distribution);
        const queryString = params.toString();
        const url = `/direct/changelogs?${queryString}`;
        const response = await this.get({
            url
        });
        const transformedChangelogs = response.data.changelogs.map(transformChangelog);
        return {
            ...response.data,
            changelogs: transformedChangelogs
        };
    }
    async getChangelog(changelogId, distribution) {
        try {
            const params = new URLSearchParams();
            if (distribution) {
                params.append('distribution', distribution);
            }
            const queryString = params.toString();
            const response = await this.get({
                url: `/direct/changelogs/${changelogId}${queryString ? `?${queryString}` : ''}`
            });
            return transformChangelog(response.data.changelog);
        } catch  {
            return null;
        }
    }
    async getDownloadUrl(changelogId, distribution) {
        const response = await this.get({
            url: `/direct/changelogs/${changelogId}/download?distribution=${distribution}`
        });
        return response.data;
    }
    // Format file size for display
    formatFileSize(bytes) {
        if (!bytes) return 'Unknown size';
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = [
            'Bytes',
            'KB',
            'MB',
            'GB'
        ];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }
    // Get change type label and color
    getChangeTypeLabel(type) {
        const labels = {
            added: {
                label: 'Added',
                color: 'text-green-600 bg-green-50'
            },
            changed: {
                label: 'Changed',
                color: 'text-blue-600 bg-blue-50'
            },
            deprecated: {
                label: 'Deprecated',
                color: 'text-yellow-600 bg-yellow-50'
            },
            removed: {
                label: 'Removed',
                color: 'text-red-600 bg-red-50'
            },
            fixed: {
                label: 'Fixed',
                color: 'text-purple-600 bg-purple-50'
            },
            security: {
                label: 'Security',
                color: 'text-orange-600 bg-orange-50'
            },
            breaking: {
                label: 'Breaking',
                color: 'text-red-600 bg-red-50'
            }
        };
        return labels[type] || {
            label: type,
            color: 'text-gray-600 bg-gray-50'
        };
    }
}
